module.exports = __webpack_public_path__ + "static/media/back-arrow.6f670c5e.svg";